module.exports = __webpack_public_path__ + "img/fudai.17bfc595.png";